// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"hero_heroContainer__Y3ryJ","cardContent":"hero_cardContent__4DSqy","numberFire":"hero_numberFire__H0qWp"};